import { render, staticRenderFns } from "./LoteMinimo.vue?vue&type=template&id=90d4a2e6"
import script from "./LoteMinimo.vue?vue&type=script&lang=js"
export * from "./LoteMinimo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports